import React, {useEffect, useRef, useState} from 'react';
import {useField} from '@unform/core';
import Switch from 'react-switch';

import './style.sass';
import PropTypes from 'prop-types';

const ToggleButton = ({name, id, disabled = false, onValueChange}) => {
    const ref = useRef(null);
    const onValueChangeRef = useRef(onValueChange);
    onValueChangeRef.current = onValueChange;
    const {fieldName, registerField, defaultValue} = useField(name);
    const [checked, onChangeChecked] = useState(defaultValue || false);

    const handleOnChange = (newValue) => {
        onChangeChecked(newValue);

        if (ref.current) {
            ref.current.checked = newValue;
        }

        if (onValueChangeRef.current) onValueChangeRef.current(newValue);
    };

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: ref.current,
            path: 'checked',
            getValue: (_ref) => _ref.checked ?? defaultValue,
            setValue: (_ref, value) => {
                _ref.checked = value;
                onChangeChecked(value);
                if (onValueChangeRef.current) onValueChangeRef.current(value);
            },
            clearValue: (_ref) => {
                _ref.checked = false;
                onChangeChecked(false);
                if (onValueChangeRef.current) onValueChangeRef.current(false);
            },
        });
    }, [fieldName, registerField, defaultValue]);

    return (
        <Switch
            name={fieldName}
            id={id}
            disabled={disabled}
            ref={ref}
            onChange={handleOnChange}
            checked={checked}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={30}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="switch-button"
        />
    );
};

ToggleButton.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    onValueChange: PropTypes.func,
};

export default ToggleButton;
